import OffersAndPromotionsIcon from '@material-ui/icons/LocalOffer';
import OffersAndPromotionsList from './OffersAndPromotionsList';

const OffersAndPromotionsModule = {
    list: OffersAndPromotionsList,
    icon: OffersAndPromotionsIcon,
}; export default OffersAndPromotionsModule;